import Button from '@doordash/component-button'
import { Text, Inset, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import { CheckrStatus, ThinFileStatus } from '../../../models/types'
import { AlertWrapper } from './styles'

import { background } from './strings'

type BackgroundStepProps = {
  status: CheckrStatus
  email: string
  isComplete: boolean
  backgroundCheckCompletionUrl?: string
  trackConfirmationPageClick?: (string) => Promise<any>
  thinFileStatus?: ThinFileStatus
}

const BackgroundCheckStep: React.SFC<BackgroundStepProps> = ({
  status,
  email,
  isComplete,
  trackConfirmationPageClick,
  backgroundCheckCompletionUrl,
  thinFileStatus,
}) => {
  const clearThinFile = thinFileStatus === ThinFileStatus.Clear
  return (
    <StackChildren>
      {isComplete || status === CheckrStatus.Clear ? (
        <Text style={Text.Styles.SectionSubtext}>
          {clearThinFile && background.completeText()}
          {!clearThinFile && (
            <AlertWrapper>
              <Inset size={Inset.Sizes.XxSmall}>
                <Text style={Text.Styles.Primary} weight={Text.Weights.Bold}>
                  {background.alertTitle()}
                </Text>
                <Text>{background.thinFileAlert()}</Text>
              </Inset>
            </AlertWrapper>
          )}
        </Text>
      ) : status === CheckrStatus.NeedsAttention ? (
        <AlertWrapper>
          <Inset size={Inset.Sizes.XxSmall}>
            <Text style={Text.Styles.Primary} weight={Text.Weights.Bold}>
              {background.alertTitle()}
            </Text>
            <Text>
              {background.alertBody()}
              <Text display={Text.DisplayModes.Inline}>{email}.</Text>
            </Text>
          </Inset>
        </AlertWrapper>
      ) : (
        <Text style={Text.Styles.SectionSubtext}>
          {status === CheckrStatus.Delayed
            ? background.delayedTimeText()
            : background.timeText()}
        </Text>
      )}
      {clearThinFile && (
        <Button
          type={Button.Types.PrimaryPill}
          isInline
          size={Button.Sizes.Small}
          href={backgroundCheckCompletionUrl || 'https://applicant.checkr.com/'}
          tag="a"
          target={'_blank'}
          onClick={e => {
            trackConfirmationPageClick('background_check_status_button')
            e.stopPropagation()
          }}
        >
          {background.button()}
        </Button>
      )}
    </StackChildren>
  )
}
const mapDispatchToProps = {
  trackConfirmationPageClick: events.trackConfirmationPageClick,
}
export default connect(null, mapDispatchToProps)(BackgroundCheckStep)
